import React, { Component } from "react";
import { Switch, Redirect, Route, withRouter } from "react-router-dom";

import Header from "components/Admin/Header/Header";
import Footer from "components/Admin/Footer/Footer";
import Sidebar from "components/Admin/Sidebar/Sidebar";
// import { hasPermission } from '../../helper/hasPermission';
import dashboardRoutes from "routes/dashboard.jsx";
//import { AdminAuthRoute } from "helper/PrivateRouteAdmin";
import { alertActions } from "redux/actions/alert-actions";
import { settingsActions } from "redux/actions/settings-actions";
import { connect } from "react-redux";
import MessageCom from "./Message";
import arrowImg from "../../assets/img/arrow_down.png";
import { history } from "helper/history";
import { loadProgressBar } from "axios-progress-bar";
import ErrorBoundary from "./ErrorBoundary";
import "axios-progress-bar/dist/nprogress.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../assets/css/animate.min.css";
import "../../assets/css/gen_classes.css";
import "../../assets/sass/light-bootstrap-dashboard.css?v=1.2.0";
import "../../assets/css/demo.css";
import "../../assets/css/pe-icon-7-stroke.css";
import "../../assets/fonts/robotoFont.css";
import $ from "jquery";
import { hasPermission } from 'helper/hasPermission';
//import { listActions } from "../../redux/actions/list-actions";

class DashboardPage extends Component {
    constructor(props) {
        super(props);
        this.props.showLoaderCall();
        this.hideCanvasMenu = this.hideCanvasMenu.bind(this);
        this.showMobileNav = this.showMobileNav.bind(this);
        this.state = {
            showBackBtn: true,
            canvasMenuToggle: false
        }
        history.listen((location, action) => {
            this.props.clearCall();
        });
        this.closeSideBarMenu = this.closeSideBarMenu.bind(this);
    }
    closeSideBarMenu() {
        this.refs.child.showCanvasMenu(true);
    }

    // showCanvasMenu(event, check) {
    //     event.stopPropagation();
    //       if (check) {
    //           this.setState({ canvasMenuToggle: false }, function() {
    //                 $(".sidebar").removeClass("showSideNav").css("overflow", "hidden");
    //                 $("#main-logo").show();
    //                 $(".main-panel").css({ width: "calc(100% - 50px)" });
    //           });
    //       } else {
    //           this.setState({ canvasMenuToggle: true }, function() {
    //                 $(".sidebar").addClass("showSideNav");
    //                 $("#main-logo").hide();
    //                 var sub_height = $(".sidebar").outerWidth();
    //                 $(".main-panel").css({
    //                     width: "calc(100% - " + sub_height + "px)"
    //                 });
    //                 $(".sidebar").css("overflow", "visible");
    //           });
    //       }
    //   }

    showSideMenu = (event, check) => {
        event.stopPropagation();
        this.setState({ canvasMenuToggle: true }, function () {
            $(".sidebar").addClass("showSideNav");
            $("#main-logo").hide();
            var sub_height = $(".sidebar").outerWidth();
            $(".main-panel").css({
                width: "calc(100% - " + sub_height + "px)"
            });
            $(".sidebar").css("overflow", "visible");
        });
    }

    showMobileNav = () => {
        $(".sidebar").toggleClass("isOpen");
    }

    hideCanvasMenu = (event) => {
        event.stopPropagation();
        this.setState({ canvasMenuToggle: false }, function () {
            $(".sidebar").removeClass("showSideNav").css("overflow", "hidden");;
            $("#main-logo").show();
            $(".main-panel").css({ width: "calc(100% - 50px)" });
        });
    }

    showBackBtn = () => {
        let urls = [
            "/Admin/dashboard"
        ]

        urls.forEach((item, index) => {
            console.log(item, this.props.location.pathname)
            if (item === this.props.location.pathname) {
                // this.setState({
                //     showBackBtn: false
                // })

                return false;
            }
            else {
                // this.setState({
                //     showBackBtn: true
                // });
                return true;
            }
        })
    }

    render() {
        const { showLoader } = this.props;
        return (
            <div className="wrapper">

                <Sidebar toggleMenu={this.showMobileNav} canvasMenuToggle={this.state.canvasMenuToggle} showSideMenu={(event) => this.showSideMenu(event, this.state.canvasMenuToggle)}
                    hideCanvasMenu={(event) => this.hideCanvasMenu(event, this.state.canvasMenuToggle)}
                    {...this.props}
                    closeSideBarMenuPro={this.closeSideBarMenu}
                />
                <div id="main-panel" className="main-panel" ref="mainPanel">
                    <Header toggleMenu={this.showMobileNav} hideCanvasMenu={(event) => this.hideCanvasMenu(event)} showCanvasMenu={(event) => this.showCanvasMenu(event, this.state.canvasMenuToggle)} canvasMenuToggle={this.state.canvasMenuToggle} {...this.props} ref="child" />
                    <div>
                        <MessageCom />
                        {loadProgressBar({ showSpinner: showLoader })}
                    </div>
                    {
                        /* ((this.props.location.pathname !== "/Admin/dashboard" && !this.props.location.pathname.includes('transformation-rules')) || this.props.location.pathname.includes('transformation-rules/edit')) */
                        false
                        && (
                            <div
                                className="text-left backbutton">
                                <button
                                    onClick={() => {
                                        this.props.history.goBack();
                                    }}
                                    className="backButton pt-sm no_radius pb-sm primary text-xs btn btn-sm btn-info"
                                >
                                    <img src={arrowImg} alt="Arrow" width="15" />
                                </button>
                            </div>
                        )}
                    <ErrorBoundary>
                        <Switch>
                            {dashboardRoutes.map(
                                (prop, key) => {
                                    if (prop.redirect) {
                                        return (
                                            <Redirect
                                                from={prop.path}
                                                to={prop.to}
                                                key={key}
                                            />
                                        );
                                    }
                                    // else if (hasPermission(prop.permission)) {
                                    return (
                                        <Route
                                            path={prop.path}
                                            key={key}
                                            render={() =>
                                                localStorage.getItem("user") ? (
                                                    <prop.component
                                                        title={prop.title}
                                                    />
                                                ) : (
                                                        // <Component {...props} {...matchProps} />
                                                        <Redirect
                                                            to={{
                                                                pathname:
                                                                    "/Admin-login",
                                                                state: {
                                                                    from:
                                                                        prop.location
                                                                }
                                                            }}
                                                        />
                                                    )
                                            }
                                        />
                                    );
                                    // }
                                }
                            )}
                            }
                        </Switch>
                    </ErrorBoundary>
                    <Footer />
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { alert } = state;
    const { showLoader } = state.settingsReducer;
    const typeOfAlert = typeof alert.message;
    // console.log('showLoader', showLoader);
    return {
        alert,
        typeOfAlert,
        showLoader
    };
}

const mapDispatchToProps = dispatch => {
    return {
        showLoaderCall: () => {
            dispatch(settingsActions.showLoader(true));
        },
        clearCall: () => {
            dispatch(alertActions.clear());
        }
    };
};

const Dashboard = withRouter(
    connect(mapStateToProps, mapDispatchToProps)(DashboardPage)
);

export default Dashboard;



// WEBPACK FOOTER //
// ./src/layouts/Dashboard/Dashboard.jsx